import { useAdministrativeContext } from '../../../../../../pages/administrativePanel/administrativePanelContext'
import { DotTypingLoader } from '../../../../../loaders/dotTypingLoader'
import { SpaceLoader } from '../../../../../loaders/spaceLoader'
import { useAuth } from '../../../../../../context/AuthContext'
import { api } from '../../../../../../services/api'
import { Button } from '../../../../../Button'
import { FaArrowLeft } from 'react-icons/fa'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Countries } from './countries'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'


import { Container, CountriesContainer, ContainerButton } from './style';


export function RegionSelection({ setSelectionDetails }) {
    const { signOut } = useAuth()
    const [businessesLocations, setBusinessesLocations] = useState([])

    const [isLoadingGettingStates, setIsLoadingGettingStates] = useState(false)
    const [isLoadingBusinessLocations, setIsLoadingBusinessLocations] = useState(true)

    const [listStatesToSearch, setListStatesToSearch] = useState([])

    const { applyingPreferences, setFranchiseListCodesSelected } = useAdministrativeContext()

    const history = useHistory()

    const dispatch = useDispatch()
    
    useEffect(() => {
        async function fetchData() {
            try{
                await api.get('/getBusinessesLocations/' + localStorage.getItem('@Inoveclube:token'), {
                    headers:{
                        token: localStorage.getItem('@Inoveclube:token')
                    }
                }).then(response => {
                    setBusinessesLocations(response.data)
                })
                setIsLoadingBusinessLocations(false)

            }catch{
                signOut()
                history.push('/login')
                setIsLoadingBusinessLocations(false)
                toast.error('Algo deu errado, faça o login novamente')
            }
           
        }
        fetchData()
    }, [signOut, history])

    
    async function handleSearchBusinessesForState() {
        setIsLoadingGettingStates(true)

        await api.post('./getBusinessesStates/' + localStorage.getItem('@Inoveclube:token'), {states: listStatesToSearch}, {
            headers: {
                token: localStorage.getItem('@Inoveclube:token')
            }
        }).then(response => applyingPreferences(2, response.data.businesses))

        setIsLoadingGettingStates(false)
        setFranchiseListCodesSelected([])
        dispatch({type: '', title: 'Filtrar empresas' })
    }


    return(
        <Container>

            {
                isLoadingBusinessLocations ? 
                <SpaceLoader colorLoader={'var(--colorFontsCardsDashboard)'} />
                :
                <>
                    <button 
                        className='backToMenu'
                        onClick={() => setSelectionDetails(null)}
                    >
                        <FaArrowLeft /> Menu Principal
                    </button>


                    <h2>Buscar Empresas</h2>

            
                    <CountriesContainer>
                        {
                            businessesLocations.map(country =>(
                                <Countries 
                                    key={country.idCountry}
                                    country={country}
                                    setListStatesToSearch={setListStatesToSearch}
                                    listStatesToSearch={listStatesToSearch}
                                />
                            ))
                        }
                    </CountriesContainer>
    
                </>
            }

            <ContainerButton isDisabled={listStatesToSearch.length === 0}>
                <Button
                    onClick={handleSearchBusinessesForState}
                    background="#7A05A7"
                    color="#FFF"
                >
                    {isLoadingGettingStates ? 
                        <DotTypingLoader />
                        :
                        'Aplicar'
                    }
                </Button>
            </ContainerButton>

        </Container>
    )
    
}
